import { inspectionsService } from '@/services/inspections';
import type { PolicyInspectionsApiResponse } from '@/services/inspections/types';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

interface UsePolicyInspectionsOptions {
  enabled?: boolean;
}

export function usePolicyInspections(
  policyId: string | null | undefined,
  options: UsePolicyInspectionsOptions = {}
) {
  const { enabled = true } = options;

  return useQuery<PolicyInspectionsApiResponse>({
    queryKey: ['policy-inspections', policyId],
    queryFn: async () => {
      if (!policyId?.trim()) {
        throw new Error('PolicyId inválido');
      }

      const response =
        await inspectionsService.getInspectionsByPolicyId(policyId);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar inspeções da proposta'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
    enabled: enabled && Boolean(policyId?.trim()),
  });
}
